import * as React from 'react';
import { APIRequest } from '@reverbdotcom/discovery-ui';
import UrlHelpers from '../../../shared/url_helpers';
import Loading from '../../../shared/loading';

class Reports extends React.Component {
  constructor() {
    super();

    this.state = {
      priceDropCount: 0,
      error: false,
      loaded: false,
    };
  }

  componentDidMount() {
    this.fetchOverPricedCount();
  }

  fetchOverPricedCount() {
    APIRequest.V3.get('/api/reports/price_drop_candidates/count')
      .then(response => this.setState({ priceDropCount: response.count, loaded: true }))
      .fail(() => this.setState({ error: true }));
  }

  renderLoading() {
    return (
      <Loading
        loaded={this.state.loaded}
        hasError={this.state.error}
        errorMessage={I18n.t('js.dashboard.selling.reports.priceDropListings.error')}
      />
    );
  }

  renderDescription() {
    return (
      I18n.t(
        'js.dashboard.selling.reports.priceDropListings.countDescription',
        {
          strongOpen: '<span class="weight-bold">',
          count: this.state.priceDropCount,
          strongClose: '</span>',
        },
      )
    );
  }

  renderOverPricedTab() {
    if (!this.state.loaded) { return this.renderLoading(); }
    const priceDropListingsReportPath = UrlHelpers.priceDropListingsReportPath();
    return (
      <div className="ptb-1 plr-1">
        <div className="g-container">
          <div className="g-col-8 g-col-mobile-12">
            <h3 className="heading-3 mb-half normal">{I18n.t('js.dashboard.selling.reports.priceDropListings.title')}</h3>
            <p dangerouslySetInnerHTML={{ __html: this.renderDescription() }} />
          </div>
          <div className="g-col-4 g-col-mobile-12">
            <a
              className="button button--orange wide mt-half mobile-mt-1"
              href={priceDropListingsReportPath}
            >
              {I18n.t('js.dashboard.selling.reports.priceDropListings.reportButton')}
            </a>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className=".remote-pagination-container">
        {this.renderOverPricedTab()}
      </div>
    );
  }
}
export default Reports;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/reports/reports.jsx